module.exports = __webpack_public_path__ + "static/img/pay-wxpay.b442c63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/plane/pay-wxpay.png
// module id = c9go
// module chunks = 4